<template>
  <div id="editor"></div>
</template>

<script>
export default {
  data() {
    return {
      quill: null
    }
  },
  mounted() {
    this.quill = new Quill('#editor', {
      theme: 'snow',
       modules: {
        toolbar: [
          ['bold', 'italic', 'underline', 'strike', 'link'],
          [{ 'list': 'ordered' }, { 'list': 'bullet'}, { 'indent': '-1' }, { 'indent': '+1' }]
        ]
      }
    })
  },
  methods: {
    getQuillBody() {
     const editor =  document.getElementById('editor')
     
     if(editor && editor.children[0])
      return editor.children[0].innerHTML
     return ''
    },
    clearData() {
      const editor =  document.getElementById('editor')
     
     if(editor && editor.children[0]) {
      editor.children[0].innerHTML = ''
      editor.children[0].innerText = ''
     }
    }
  },
}
</script>

<style></style>